// request animation frame
window.flags = {
  scrolled: false,
  pauseScrolling: false,
  resized: false,
  resizedWidth: false,
  resizedHeight: false,
  pauseResizing: false,
};

window.timers = {
  scroll: -1,
  resize: -1,
  delta: 16.67 //  (1/60fps) / 1000ms = 16.67ms per frame
};

window.util = {
  width: window.innerWidth,
  lastWidth: window.innerWidth,
  height: window.innerHeight,
  lastHeight: window.innerHeight,
  scrollX: window.pageXOffset,
  lastScrollX: 0,
  scrollY: window.pageYOffset,
  lastScrollY: 0,
  scrollingDown: true
};

// prepare scroll function
window.addEventListener('scroll', () => {
  window.flags.scrolled = true;
  window.util.scrollX = window.pageXOffset;
  window.util.scrollY = window.pageYOffset;

  if(window.util.scrollY <= window.util.lastScrollY) {
    window.util.scrollingDown = false;
  } else {
    window.util.scrollingDown = true;
  }
  window.util.lastScrollY = window.util.scrollY;

  if(window.timers.scroll !== -1) {
    clearTimeout(window.timers.scroll);
  }

  window.timers.scroll = window.setTimeout(() => {
    window.flags.scrolled = false;
  }, window.timers.delta);
});

// prepare resize function
window.addEventListener('resize', () => {
  window.flags.resized = true;
  window.util.width = window.innerWidth;
  window.util.height = window.innerHeight;

  if(window.util.width !== window.util.lastWidth) {
    window.flags.resizedWidth = true;
  }
  window.util.lastWidth = window.util.width;

  if(window.util.height !== window.util.lastHeight) {
    window.flags.resizedHeight = true;
  }
  window.util.lastHeight = window.util.height;

  if(window.timers.resize !== -1) {
    clearTimeout(window.timers.resize);
  }

  window.timers.resize = window.setTimeout(() => {
    window.flags.resized = false;
    window.flags.resizedWidth = false;
    window.flags.resizedHeight = false;
  }, window.timers.delta);
});

const requestScrollAnimation = (callback, delay) => {
  delay = delay || window.timers.delta;

  return setInterval(() => {
    if(window.flags.scrolled) {
      window.requestAnimationFrame(callback);
    }
  }, delay);
};

const requestResizeAnimation = (callback, delay) => {
  delay = delay || window.timers.delta;

  return setInterval(() => {
    if(window.flags.resized) {
      window.requestAnimationFrame(callback);
    }
  }, delay);
};

const requestResizeWidthAnimation = (callback, delay) => {
  delay = delay || window.timers.delta;

  return setInterval(() => {
    if(window.flags.resizedWidth) {
      window.requestAnimationFrame(callback);
    }
  }, delay);
};

const requestResizeHeightAnimation = (callback, delay) => {
  delay = delay || window.timers.delta;

  return setInterval(() => {
    if(window.flags.resizedHeight) {
      window.requestAnimationFrame(callback);
    }
  }, delay);
};

export { requestScrollAnimation, requestResizeAnimation, requestResizeWidthAnimation, requestResizeHeightAnimation };